const actionHandlers = {
    REQUEST_VIEW_SEARCH: () => false,
    REQUEST_BANKRUPTCY_SEARCH: () => false,
    REQUEST_BANKRUPTCY_LOCAL_SEARCH: () => false,
    REQUEST_APPELLATE_SEARCH: () => false,
    REQUEST_CIVIL_SEARCH: () => false,
    REQUEST_CRIMINAL_SEARCH: () => false
}

export default (immediateSearch = false, action) => {
    const actionHandler = actionHandlers[action.type]

    return (actionHandler)
        ? actionHandler(immediateSearch, action)
        : immediateSearch
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/immediateSearch.js
 **/